import { FunctionComponent, useEffect } from 'react';

import { CPFFieldType } from '../../types';
import InputMask from 'react-input-mask';
import { TextField } from '.';
import { getIn } from 'formik';
import { strip as stripCPF } from '@fnando/cpf';

const cpfMask = '999.999.999-99';

const CPFField: FunctionComponent<CPFFieldType> = ({ formikProps, label, name, disabled, required, ...props }) => {
  useEffect(() => {
    formikProps.validateForm();
  }, [getIn(formikProps.values, name)]);

  return (
    <TextField
      {...{
        component: InputMask,
        disabled,
        formikProps,
        label,
        mask: cpfMask,
        name,
        onBlur: (event: any) => {
          formikProps.setFieldValue(name, stripCPF(event.target.value));
          formikProps.setFieldTouched(name, true);
        },
        onChange: (event: any) => {
          formikProps.setFieldValue(name, stripCPF(event.target.value));
          formikProps.setFieldTouched(name, true);
        },
        placeholder: cpfMask,
        required,
      }}
      {...props}
    />
  );
};

export default CPFField;
